import { apiClient } from './apiClient';

export const companyService = {
  /**
   * Get current company profile
   */
  async getCurrentCompany() {
    return apiClient.get('/api/companies/me');
  },

  /**
   * Update current company profile (admin only)
   * @param {Object} data - Company data to update
   * @param {string} data.name - Company name
   * @param {string} data.industry - Industry
   * @param {string} data.size - Company size (enum)
   * @param {string} data.address - Street address
   * @param {string} data.city - City
   * @param {string} data.state - State
   * @param {string} data.zipCode - ZIP code
   * @param {string} data.country - Country
   * @param {string} data.website - Website URL
   * @param {string} data.phone - Phone number
   * @param {string} data.timezone - Timezone
   */
  async updateCompany(data) {
    return apiClient.put('/api/companies/me', data);
  },
};

// Company size options that match backend enum
export const COMPANY_SIZE_OPTIONS = [
  { value: 'SMALL', label: '1-50 employees' },
  { value: 'MEDIUM', label: '51-250 employees' },
  { value: 'LARGE', label: '251-1000 employees' },
  { value: 'ENTERPRISE', label: '1000+ employees' },
];

// Industry options
export const INDUSTRY_OPTIONS = [
  'Manufacturing',
  'Healthcare',
  'Technology',
  'Retail',
  'Construction',
  'Transportation',
  'Energy',
  'Education',
  'Hospitality',
  'Other',
];

// Timezone options (sorted west-to-east by UTC offset)
export const TIMEZONE_OPTIONS = [
  { value: 'Pacific/Honolulu', label: '(UTC-10:00) Hawaii Time' },
  { value: 'America/Anchorage', label: '(UTC-09:00) Alaska Time' },
  { value: 'America/Los_Angeles', label: '(UTC-08:00) Pacific Time (PT)' },
  { value: 'America/Denver', label: '(UTC-07:00) Mountain Time (MT)' },
  { value: 'America/Chicago', label: '(UTC-06:00) Central Time (CT)' },
  { value: 'America/New_York', label: '(UTC-05:00) Eastern Time (ET)' },
  { value: 'America/Toronto', label: '(UTC-05:00) Toronto' },
  { value: 'America/Sao_Paulo', label: '(UTC-03:00) Sao Paulo' },
  { value: 'Europe/London', label: '(UTC+00:00) London (GMT/BST)' },
  { value: 'Europe/Paris', label: '(UTC+01:00) Paris (CET)' },
  { value: 'Europe/Berlin', label: '(UTC+01:00) Berlin (CET)' },
  { value: 'Africa/Lagos', label: '(UTC+01:00) Lagos (WAT)' },
  { value: 'Africa/Cairo', label: '(UTC+02:00) Cairo (EET)' },
  { value: 'Africa/Johannesburg', label: '(UTC+02:00) Johannesburg (SAST)' },
  { value: 'Europe/Istanbul', label: '(UTC+03:00) Istanbul (TRT)' },
  { value: 'Asia/Beirut', label: '(UTC+02:00) Beirut (EET)' },
  { value: 'Asia/Riyadh', label: '(UTC+03:00) Riyadh (AST)' },
  { value: 'Asia/Baghdad', label: '(UTC+03:00) Baghdad (AST)' },
  { value: 'Asia/Dubai', label: '(UTC+04:00) Dubai (GST)' },
  { value: 'Asia/Karachi', label: '(UTC+05:00) Karachi (PKT)' },
  { value: 'Asia/Kolkata', label: '(UTC+05:30) India (IST)' },
  { value: 'Asia/Shanghai', label: '(UTC+08:00) China (CST)' },
  { value: 'Asia/Singapore', label: '(UTC+08:00) Singapore (SGT)' },
  { value: 'Asia/Seoul', label: '(UTC+09:00) Seoul (KST)' },
  { value: 'Asia/Tokyo', label: '(UTC+09:00) Tokyo (JST)' },
  { value: 'Australia/Sydney', label: '(UTC+10:00) Sydney (AEST)' },
  { value: 'Pacific/Auckland', label: '(UTC+12:00) Auckland (NZST)' },
];
